exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-f2ad4e12]{display:inline-block;font-size:14px;line-height:40px;margin-left:20px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-f2ad4e12]{color:#97a8be;cursor:text}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2ad4e12","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/Breadcrumb.vue
// module id = 1147
// module chunks = 0